import { filterOnlyNeededGames, getCurrentSeason } from "@/helper/api";
import { localePath } from "@/helper/urlHelper";
import prisma from "@/helper/client";
import { Season } from "@/models/Season";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { Footer } from "../../../../components/Footer";
import { PlayerDetail } from "../../../../components/Players/PlayerDetail";
import { Nav } from "../../../../components/common/FrontendNav";
import { LeaguePlayerWithTeamAndGames } from "../../../../models/LeaguePlayer";

export async function getServerSideProps(context: any) {
  const { res } = context;
  res.setHeader(
    "Cache-Control",
    "public, max-age=3600, stale-while-revalidate=4000"
  );
  const { player: playerId } = context.query;

  const player = await prisma.leaguePlayer.findFirst({
    where: { id: playerId },
    include: {
      seasonPlayer: { include: { seasonTeam: true, outfitter: true } },
      awayGames: {
        where: { DBStatus: "Active" },
        orderBy: { index: "asc" },
        include: {
          match: true,
          homePlayer: {
            include: { seasonPlayer: { include: { seasonTeam: true } } },
          },
          awayPlayer: {
            include: { seasonPlayer: { include: { seasonTeam: true } } },
          },
        },
      },
      homeGames: {
        where: { DBStatus: "Active" },
        orderBy: { index: "asc" },
        include: {
          match: true,
          homePlayer: {
            include: { seasonPlayer: { include: { seasonTeam: true } } },
          },
          awayPlayer: {
            include: { seasonPlayer: { include: { seasonTeam: true } } },
          },
        },
      },
    },
  });

  if (!player) {
    return {
      redirect: {
        destination: localePath(context.locale, "/bundesliga/players"),
        permanent: false,
        basePath: false,
      },
    };
  }
  player.homeGames = (await filterOnlyNeededGames(player.homeGames)) as any;
  player.awayGames = (await filterOnlyNeededGames(player.awayGames)) as any;

  const season = await getCurrentSeason();
  return {
    props: {
      player: {
        ...player,
        games: [...player.homeGames, ...player.awayGames].sort(
          (a, b) =>
            a.match.timeStamp - b.match.timeStamp || a.index - b.index
        ),
      },
      season,
      ...(await serverSideTranslations(context.locale)),
    },
  };
}

interface BundesligaPlayerPageProps {
  player: LeaguePlayerWithTeamAndGames;
  season: Season;
}
export default function BundesligaPlayerPage({
  player,
  season,
}: BundesligaPlayerPageProps) {
  const { t } = useTranslation();

  return (
    <>
      <Head>
        <title>{`${t("Table_Tennis")} Bundesliga - TTBL - ${
          player.seasonPlayer.firstName
        } ${player.seasonPlayer.lastName}`}</title>
        {player.seasonPlayer.imageUrl && (
          <>
            <meta
              name="og:image"
              content={player.seasonPlayer.imageUrl}
              key="og:image"
            />
            <meta
              name="twitter:image"
              content={player.seasonPlayer.imageUrl}
              key="twitter:image"
            />
          </>
        )}
      </Head>
      <div>
        <Nav
          endpointSelectionString={
            player.seasonPlayer.firstName + " " + player.seasonPlayer.lastName
          }
        />
        <PlayerDetail player={player} league="Bundesliga" season={season} />
        <Footer />
      </div>
    </>
  );
}
